import { inject, Injectable } from '@angular/core'
import { map, Observable } from 'rxjs'
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http'

export type FileUploadType = 'agenda' | 'recording' | 'custom-document'

@Injectable({
  providedIn: 'root',
})
export class UploadsService {
  http = inject(HttpClient)

  uploadCustomDocument(chosenFile: File): Observable<{ progress: number; uploadKey: string | null }> {
    return this.upload('custom-document', chosenFile)
  }

  uploadAgenda(chosenFile: File): Observable<{ progress: number; uploadKey: string | null }> {
    return this.upload('agenda', chosenFile)
  }

  uploadRecording(chosenFile: File): Observable<{ progress: number; uploadKey: string | null }> {
    return this.upload('recording', chosenFile)
  }

  upload(type: FileUploadType, chosenFile: File): Observable<{ progress: number; uploadKey: string | null }> {
    let formData: FormData = new FormData()
    formData.append('file', chosenFile)
    return this.http
      .post(`/api/uploads/${type}`, formData, {
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        map((event: HttpEvent<any>) => {
          switch (event.type) {
            case HttpEventType.UploadProgress:
              const progress = event.total ? Math.round((100 * event.loaded) / event.total) : 0
              return { progress, uploadKey: null }
            case HttpEventType.Response:
              return { progress: 100, uploadKey: event.body.uploadKey }
            default:
              return { progress: 0, uploadKey: null }
          }
        })
      )
  }
}
